import {
  SHOW_PROGRESS_BAR,
  EXISTING_USER_ID,
  EXISTING_COGNITO_USERNAME,
  GET_DATA,
  GET_HIGH_SCHOOLS,
  REGISTER_USER,
  SAVE_RESULTS,
  SET_CAREER_TAB,
  SET_DEGREE_CHOICES,
  SET_DEGREE_CAREER_ID_MAP,
  GET_USER_DATA,
  SAVE_USER_CHOICES,
  SET_USER,
  SET_CAREER_DEGREE_MODALITY,
  SET_CAREER_BRIGHT_OUTLOOK_MODALITY,
  SET_MODAL_IMAGE,
  USER_LOGOUT_ONBOARDING,
  SET_FAVORITES,
} from '../actionTypes';

const getInitialState = () => ({
  careerChoices: {
    1: '',
    2: '',
    3: '',
  },

  degreeChoices: {},
  careerTabSelected: undefined,
  currentTab: 0,
  careerCardsExpanded: {
    1: false,
    2: false,
    3: false,
  },
  userId: null,
  cognitoUsername: undefined,
  highSchools: [],
  userGameResults: undefined,

  userData: {
    user: {},
    careerGameResults: [],
    degreeCareerIdMap: {},
    userIsRogue: false,
  },
  pushNotifications: {},
  showOnlineDegreesOnly: null,
  showBrightOutlookCareersOnly: false,
  modalImage: null,
  favorites: [],
  tenantId: null,
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SHOW_PROGRESS_BAR: {
      const { careerCardsExpanded } = action.payload;

      return {
        ...state,
        careerCardsExpanded,
      };
    }

    case GET_DATA: {
      const { userGameResults } = action.payload;

      return {
        ...state,
        userGameResults,
      };
    }

    case SET_DEGREE_CHOICES: {
      const { ...degreeChoices } = action.payload;

      return {
        ...state,
        degreeChoices,
      };
    }

    case SET_DEGREE_CAREER_ID_MAP: {
      const { careerChoices } = action.payload;

      return {
        ...state,
        careerChoices,
      };
    }

    case SET_CAREER_TAB: {
      const { careerInfo, careerTabSelected, currentTab } = action.payload;

      return {
        ...state,
        degreeChoices: { ...careerInfo },
        careerTabSelected,
        currentTab,
      };
    }

    case EXISTING_USER_ID: {
      const user_id = action.payload;

      return {
        ...state,
        userId: user_id,
      };
    }

    case EXISTING_COGNITO_USERNAME: {
      const cognito_username = action.payload;

      return {
        ...state,
        cognitoUsername: cognito_username,
      };
    }

    case GET_HIGH_SCHOOLS: {
      const { highSchools } = action.payload;

      return {
        ...state,
        highSchools,
      };
    }

    case REGISTER_USER: {
      const { userId } = action.payload;

      return {
        ...state,
        userId,
      };
    }

    case SAVE_RESULTS: {
      const { userData } = action.payload;
      const careerGameResults = userData.careerGameResults;
      const degreeCareerIdMap = userData.degreeCareerIdMap;

      return {
        ...state,
        userData: {
          ...state.userData,
          degreeCareerIdMap,
          careerGameResults,
        },
      };
    }

    case GET_USER_DATA: {
      const { userData } = action.payload;

      return {
        ...state,
        userData: {
          ...state.userData,
          ...userData,
        },
      };
    }

    case SAVE_USER_CHOICES: {
      const careers = action.payload;
      const career1 = careers[0]
        ? {
            titleEn: careers[0].titleEn,
            categoryImageUrl1: careers[0].categoryImageUrl1,
            id: careers[0].id,
            onetCode: careers[0].onetCode,
          }
        : '';
      const career2 = careers[1]
        ? {
            titleEn: careers[1].titleEn,
            categoryImageUrl2: careers[1].categoryImageUrl2,
            id: careers[1].id,
            onetCode: careers[1].onetCode,
          }
        : '';
      const career3 = careers[2]
        ? {
            titleEn: careers[2].titleEn,
            categoryImageUrl3: careers[2].categoryImageUrl3,
            id: careers[2].id,
            onetCode: careers[2].onetCode,
          }
        : '';

      return {
        ...state,
        careerChoices: {
          1: career1,
          2: career2,
          3: career3,
        },
      };
    }

    case SET_USER: {
      const { user } = action.payload;

      if (!user) {
        return getInitialState();
      }

      return state;
    }

    case SET_MODAL_IMAGE: {
      const image = action.payload;

      return {
        ...state,
        modalImage: image,
      };
    }

    case SET_CAREER_DEGREE_MODALITY:
      return {
        ...state,
        showOnlineDegreesOnly: action.payload,
      };

    case SET_CAREER_BRIGHT_OUTLOOK_MODALITY:
      return {
        ...state,
        showBrightOutlookCareersOnly: action.payload,
      };

    case USER_LOGOUT_ONBOARDING: {
      return getInitialState();
    }

    case SET_FAVORITES: {
      const { favorites } = action.payload;
      if (favorites) {
        return {
          ...state,
          favorites,
        };
      }

      if (!favorites) {
        return {
          ...state,
          favorites: action.payload,
        };
      }
      return getInitialState();
    }

    default:
      return state;
  }
}
